import React, { FC } from 'react'
import { Helmet } from 'react-helmet-async'

import { getBrandConfig } from '../../../config/brands'
import { HelmetPageTitlePropertiesInterface } from './HelmetPageTitle.types'

const { brandConfig } = getBrandConfig()

export const HelmetPageTitle: FC<HelmetPageTitlePropertiesInterface> = ({ helmetTitle, pageTitle }) => (
  <Helmet title={`${brandConfig.helmet.baseTitle} | ${helmetTitle || (typeof pageTitle === 'string' ? pageTitle : '')}`}></Helmet>
)
